import React, {useState} from 'react';
import {Box, Tab, Grid2, Tabs as MuiTabs, Typography} from "@mui/material";
import OurGames from "../../components/OurGames/OurGames";
import ComingSoonGame from "../../components/OurGames/ComingSoonGame";
const Tabs: React.FC = () => {
    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Grid2 className='tabs' container justifyContent="center" alignItems="center" spacing={{xs: 1, md: 2}}
               columns={{xs: 4, sm: 8, md: 12}}>
            <Grid2 size={{xs:12}}>
                <Typography className='nameSection'>
                    Our Games
                </Typography>
            </Grid2>
            <Grid2 size={{xs:12}}>
                <MuiTabs
                    value={value}
                    onChange={handleChange}
                    centered
                    TabIndicatorProps={{style: {backgroundColor: '#EF0012', height: '4.5px', marginTop: '3.75rem' }}}
                    textColor="inherit"
                >
                    <Tab label="Table" sx={{
                        color: '#FFF',
                        textAlign: 'center',
                        fontFamily: '"Proxima Nova" , sans-serif',
                        fontSize: '1.375rem',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '1.67138rem'
                    }}/>
                    <Tab label="Slot" sx={{
                        color: '#FFF',
                        textAlign: 'center',
                        fontFamily: '"Proxima Nova", sans-serif',
                        fontSize: '1.375rem',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '1.67138rem'
                    }}/>
                    <Tab label="Crash" sx={{
                        color: '#FFF',
                        textAlign: 'center',
                        fontFamily: '"Proxima Nova" , sans-serif',
                        fontSize: '1.375rem',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '1.67138rem'
                    }}/>
                </MuiTabs>
                <Box sx={{p: 2}}>
                    {value === 0 && (
                        <OurGames/>
                    )}
                    {value === 1 && (
                        <Box textAlign="center">
                            <ComingSoonGame/>
                        </Box>
                    )}
                    {value === 2 && (
                        <Box textAlign="center">
                            <ComingSoonGame/>
                        </Box>
                    )}
                </Box>
            </Grid2>
        </Grid2>
    );
};

export default Tabs;